<template>
	<div v-if="currentPage" class="password-protection content-protected">
        <div class="inner container text-center margin-bottom-xl">
            <h2 class="titler margin-bottom-lg"> {{_('To see page please provide password')}}</h2>
            <form @submit.prevent="unlockPost" class="passowrd-form" :class="{ 'has-error' : formHasError}">
                <input :name="'post-pass-'+currentPageID" v-model="password" type="password" :placeholder="_('Password')" required/>
                <Button type="dark" uppercase bold :aria-label="_('Unlock')">{{_('Unlock')}}</Button>
            </form>
        </div>
    </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import Button from '@/components/elements/Button';

export default {
    name: 'password-preotection',
    components:{
        Button
    },
    data(){
        return{
            password: '',
            formHasError: false,
        }
    },
    computed: {
        ...mapGetters([
            'currentPage',
            'currentPageID',
            'currentPostType'
        ])
    },
    methods: {
        ...mapActions(['getPost']),
        unlockPost(){
            const VM = this;
            VM.formHasError = false;
            VM.getPost({
                limit: 1,
                type: VM.currentPostType,
                id: VM.currentPageID,
                password: VM.password
            }).then(e=>{
                if(e.data && e.data.posts && e.data.posts[0] && e.data.posts[0].is_protected){
                    VM.formHasError = true;
                }
                if(e.data && e.data.posts && !e.data.posts.length){
                    VM.formHasError = true;
                }
            })
        }
    }
}
</script>

<style lang="scss">
@import "@/assets/vars.scss";
@import "@/assets/mixins.scss";
.content-protected{
    .passowrd-form{
        display: flex;
        max-width: 460px;
        margin: 0 auto;
        &.has-error{
            animation: shake 0.82s cubic-bezier(.36,.07,.19,.97) both;
            transform: translate3d(0, 0, 0);
            backface-visibility: hidden;
            input{
                border-color: #e53935;
            }
        }
        .fill-button {
            border-top-left-radius: 0;
            border-bottom-left-radius: 0;
        }
        input{
            border: 2px solid $dark;
            border-top-left-radius: $radius;
            border-bottom-left-radius: $radius;
            background-color: $light;
            flex: 1 0 auto;
            padding: 8px 15px;
            color: $dark;
        }
    }
}

</style>
